(function($) {
    function updateHeaderOverlay() {
        if ($('.template__minimal').length > 0) {
            // Shortcircuit for minimal pages
            $('.navbar').addClass('has-overlay');
            return;
        }
        const headerHeight = 90;
        const currentScroll = $(window).scrollTop();
        const navbarToggler = $('.navbar-toggler');
        if (navbarToggler.hasClass('is-active') || currentScroll > headerHeight) {
            $('.navbar').addClass('has-overlay');
        } else {
            $('.navbar').removeClass('has-overlay');
        }
    }

    updateHeaderOverlay();
    $(window).scroll(updateHeaderOverlay);

    $('.navbar-toggler').on('click', function() {
        $(this).toggleClass('is-active');
        updateHeaderOverlay();
    });
})(jQuery);
